export const getPaymentState = (state) => {
  return state.payment.paymentState;
};

export const getPaymentErrorFields = (state) => {
  return state.payment.paymentErrorFields;
};
